export const RELATION__ACCOUNTS_STARRED = 'accountsStarred';
export const RELATION__EMPLOYERS_STARRED = 'employersStarred';
export const RELATION__CANDIDATES_STARRED = 'candidatesStarred';
export const RELATION__ENGAGEMENTS_STARRED = 'engagementsStarred';
export const RELATION__JOBS_STARRED = 'jobsStarred';